// @ts-nocheck
import * as React from "react";

const Finishing: React.FC = () => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 47 47"
            enableBackground="new 0 0 47 47;"
        >
            <g id="Calque_4">
                <g>
                    <circle fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" cx="23.5" cy="23.5" r="22" />
                    <g id="Icon-FinishingSolutions" transform="translate(965.000000, 0.000000)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            fill="#1D1D1B"
                            d="M-941.5,1.5c-12.1,0-22,9.9-22,22c0,8,4.3,15.1,10.7,18.9v-3.7h3v5.2c2.4,1,5.1,1.6,7.8,1.6V28.1h2.4v17.3
				c2.9-0.3,5.6-1.1,8-2.3v-4.3h2.4v2.9c5.8-4,9.6-10.6,9.6-18.2C-919.5,11.4-929.3,1.5-941.5,1.5z M-957.8,10.1h32.4v7.4h-32.4
				V10.1z M-956.9,18.6c-0.1-0.3-0.4-0.7-0.4-0.7h31.4c0,0-0.3,0.3-0.4,0.6c-0.1,0.3-0.2,0.8-0.2,0.8h-30.4
				C-956.8,19.3-956.8,18.9-956.9,18.6z M-925.8,19.9l-0.6,1.7h-30.2l-0.8-1.7H-925.8z M-948,34.5l-1.8,2.1V38h-3v-1.5l-1.8-2.1
				c0,0-0.2-0.4,0-0.7c0.2-0.3,0.5-0.6,0.5-0.6l2-2h1.7l2.1,2.1c0,0,0.4,0.4,0.4,0.7C-947.9,34.4-948,34.5-948,34.5z M-943.7,29.1
				c-0.3,0.8-1,1.5-1,1.5l-2.5,3l-3-3.1l-2.1,0l-3,3l-2.8-3.3c0,0-0.5-0.6-0.7-1.2c-0.2-0.6-0.2-1.5-0.2-1.5l0-0.9h15.4v0.6
				C-943.5,27.3-943.4,28.3-943.7,29.1z M-939.5,24.1c0,0.2-0.1,0.5-0.1,0.5l0,3.1l-2.4,0v-3.5c0,0-0.1-0.6-0.1-0.8
				c0.1-0.2,0.4-0.2,0.4-0.2h1.8c0,0,0.3-0.1,0.4,0.2C-939.4,23.7-939.4,23.9-939.5,24.1z M-939,23.9l0-0.5c0,0,0.1-0.3-0.1-0.4
				c-0.2-0.2-0.5-0.1-0.5-0.1h-2.4c0,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2,0.1,0.5,0.1,0.5s-0.4-0.1-0.8-0.3
				c-0.4-0.1-1.5-0.3-2.2-0.8c-0.3-0.3-0.5-0.7-0.5-0.7h10.4c0,0-0.1,0.3-0.4,0.6c-0.3,0.3-1.7,0.9-2.1,1
				C-938.4,23.6-939,23.9-939,23.9z M-929,35.4l-0.1,0.8v2.1h-2.4l0-2.3l-0.1-0.4c0,0-0.1-0.4,0-0.5c0-0.1,0.2-0.1,0.2-0.1l2,0
				c0,0,0.2,0,0.3,0.1C-928.9,35.2-929,35.4-929,35.4z M-924.3,34.2c-0.7,0.9-2.9,1.2-3.5,1.3c-0.4,0.1-0.8,0.3-0.8,0.3
				s0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.2-0.5c-0.1-0.1-0.4-0.1-0.4-0.1l-2.6,0c0,0-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.2-0.1,0.4
				c0,0.2,0.1,0.6,0.1,0.6s-0.6-0.3-1.2-0.4c-0.6-0.1-2-0.4-2.7-1c-0.7-0.6-0.7-1.5-0.7-1.5h12.8C-923.8,32.9-923.6,33.3-924.3,34.2
				z M-923.7,32.5h-13.2l-0.8-2.5v-2h14.7v1.8L-923.7,32.5z"
                        />
                        <g>
                            <path
                                id="Fill-24"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="#EE3124"
                                d="M-944.6,20.7c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3
					C-944.7,20.4-944.6,20.6-944.6,20.7"
                            />
                            <path
                                id="Fill-25"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="#EE3124"
                                d="M-940.4,20.7c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3
					C-940.5,20.4-940.4,20.6-940.4,20.7"
                            />
                            <path
                                id="Fill-26"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="#EE3124"
                                d="M-936.1,20.7c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3
					C-936.2,20.4-936.1,20.6-936.1,20.7"
                            />
                            <path
                                id="Fill-27"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="#EE3124"
                                d="M-940.4,24c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3
					C-940.6,23.7-940.4,23.8-940.4,24"
                            />
                            <path
                                id="Fill-28"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="#EE3124"
                                d="M-930,35.9c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3
					C-930.1,35.6-930,35.8-930,35.9"
                            />
                            <path
                                id="Fill-29"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="#EE3124"
                                d="M-930,37.5c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3
					C-930.1,37.1-930,37.3-930,37.5"
                            />
                            <path
                                id="Fill-30"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                fill="#EE3124"
                                d="M-950.9,33.3c0,0.2-0.2,0.3-0.3,0.3s-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3
					S-950.9,33.1-950.9,33.3"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Finishing);
